import { render } from "./OrderEgrnModal.vue?vue&type=template&id=e4ca61d8"
import script from "./OrderEgrnModal.vue?vue&type=script&lang=js"
export * from "./OrderEgrnModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Intermark\\Intermark(mobile)\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__